module.exports = __webpack_public_path__ + "img/Slide18.e01eff07.png";